import { CloudSun, Globe, Inbox, Megaphone, PlugZap } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  to: string
  labelKey: string
  icon: LucideIcon
}

export const navItems: NavItem[] = [
  { to: '/dashboard', labelKey: 'nav.dashboard', icon: CloudSun },
  { to: '/sites', labelKey: 'nav.sites', icon: Globe },
  { to: '/ads-accounts', labelKey: 'nav.adsAccounts', icon: PlugZap },
  { to: '/bindings', labelKey: 'nav.bindings', icon: Megaphone },
  { to: '/proposals', labelKey: 'nav.proposals', icon: Inbox },
]
